export default __webpack_public_path__ + "static/media/bg.4c7d4b0e.png";